import axios from "axios"
import {
    erroralert
} from "@/utils/alert";
import { useMainStore } from "@/store/piniaStore";

let requests = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || "https://apply.24cod.com",
    timeout: 15000
})

//请求拦截器
requests.interceptors.request.use(config => {


    //统一携带token
    if (config.url !== config.baseURL + "/api/user/login") {
        const store = useMainStore();
        if (store.token) config.headers.token = store.token.replace(/\"/g, "");
    }

    return config
})


//响应拦截器
requests.interceptors.response.use(res => {


    // 统一处理错误信息
    if (res.data.code !== 1 && res.data.msg != "未登录") {

        if (res.data.msg) {
            erroralert(res.data.msg)
        }

    }

    return res

}, error => {
    // 处理失败响应  

    return Promise.reject(error)

})

export default requests